// extracted by mini-css-extract-plugin
module.exports = {"signInForm":"request-new-password_signInForm__1UCFC"};